export const ACTIVITY_TYPES = [
  'Apprenticeship',
  'Boot camp',
  'Bridge training',
  'Career fair',
  'Career mentorship',
  'Career-focused research project',
  'College fair',
  'College trip',
  'Community service',
  'Entrepreneurship',
  'Guest speaker',
  'Informational interview',
  'Internship',
  'Job',
  'Job shadow',
  'Mock interview',
  'Networking activity',
  'Presentation',
  'SYEP',
  'School based enterprise',
  'Sector training',
  'Service learning',
  'Tour',
  'Trip',
  'Volunteer',
  'Workplace challenge',
  'Other',
];

export const ACTIVITY_SECTORS = [
  'All',
  'Construction',
  'Food service',
  'Health',
  'Hospitality',
  'Retail',
  'Social work',
  'Tech',
  'Transportation',
  'Other',
];
